import { FormControl, Grid, InputLabel, Select, MenuItem } from '@material-ui/core';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { useState } from 'react';
import { ServicePlan } from '../../_types/serviceplan';
import LocationSearch from '../../common/LocationSearch';
import { ISearchResult } from '../../_types/search';
import { IChangeEventHandler } from '../../_types/nav';
import { GetPlans } from '../../_service/plan';

interface Props {
    onLocationChange?: IChangeEventHandler<ISearchResult | null>;
    onPlanChange: (event: React.ChangeEvent<{ name?: string | undefined; value: unknown; }>) => void;
    planInputLabel?: string;
    planValue: string;
    plans?: Array<ServicePlan>;
    codeTypeCheck?: string;
  };
  
  export const PlanByLocationSelector: React.FC<Props> = (prop: Props) => {
  
    const useStyles = makeStyles((theme: Theme) =>
      createStyles({
        formControl: {
          margin: theme.spacing(1),
          minWidth: 120,
        },
        innerContainer: {
          borderRadius: 10,
          margin: 10,
          alignItems: 'center',
          textAlign: 'center',
          boxShadow: '2px 2px 8px rgb(50 50 93 / 20%)',
        }
      })
    );
  
    const [plans, setPlans] = useState<ServicePlan[]>([]);
    const classes = useStyles();
  
    React.useEffect(() => {
      setPlans([]);
      if (prop.plans && prop.plans.length > 0) {
        setPlans(prop.plans);
      }
  
    }, [prop.plans])

    let allPlansOrSelect;
    if(prop.codeTypeCheck !== undefined) {
      allPlansOrSelect =  (<MenuItem value={''}>Select Plan</MenuItem>);
    } else {
      allPlansOrSelect = (<MenuItem value={'all plans'}>All Plans</MenuItem>);
    }
  
    return (
      <Grid container direction="row" className={classes.innerContainer}>
          <Grid item xs={12} sm={5}>
            <FormControl variant="outlined" className={classes.formControl}>
              <LocationSearch 
                onChange={(newValue: ISearchResult | null)=>{ 
                  prop.onLocationChange && prop.onLocationChange(newValue);
                  GetPlans(newValue?.id).then(res => {
                    setPlans(res)});
                }} 
                isUniversal={false}
                inputWidth={250} />
            </FormControl>
          </Grid>
  
          <Grid item xs={12} sm={5}>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="select-label">{prop.planInputLabel || 'Plan'}</InputLabel>
            <Select
              labelId="select-label"
              id="select-outlined"
              label={prop.planInputLabel}
              value={prop.planValue}
              onChange={prop.onPlanChange}>
                {allPlansOrSelect}
                {plans.length > 0 && plans.map(plan =>
                  <MenuItem key={plan.id} value={plan.id as string}>{plan.id}: {plan.title} {prop.codeTypeCheck === 'drb' ? ("(" + plan.drb_remaining + ")") : ''} {prop.codeTypeCheck === 'otuc' ? ("(" + plan.otuc_remaining + ")") : ''}</MenuItem>
                )}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    );
  }